import { Box, IconButton } from '@material-ui/core';
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@material-ui/icons';
import React from 'react';

import { useListViewTableStore } from '~/src/dash/components/tables/ListViewTable/context';
import { spacing } from '~/src/dash/publicaUI';

interface IListViewTablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

export const ListViewTablePagination = (props: IListViewTablePaginationProps) => {
  const { count, page, rowsPerPage, onPageChange } = props;
  const { isUpdating } = useListViewTableStore();

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 4 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={isUpdating || page === 0}
        aria-label='First Page'
        style={{ padding: spacing.extraSmall }}
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={isUpdating || page === 0}
        aria-label='Previous Page'
        style={{ padding: spacing.extraSmall }}
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={isUpdating || page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='Next Page'
        style={{ padding: spacing.extraSmall }}
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={isUpdating || page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='Last Page'
        style={{ padding: spacing.extraSmall }}
      >
        <LastPage />
      </IconButton>
    </Box>
  );
};
